import React from 'react';

type MenuItem =
  | { key: string; label: string; icon: string; type?: never }
  | { type: 'heading'; key: string; label: string };

const menuItems: MenuItem[] = [
  { type: 'heading', key: 'h_system', label: 'Hệ thống' },
  { key: 'general', label: 'Cấu hình chung', icon: 'ri-settings-3-line' },
  { key: 'account', label: 'Tài khoản của tôi', icon: 'ri-user-3-line' },
  { key: 'notifications', label: 'Thông báo', icon: 'ri-notification-3-line' },

  { type: 'heading', key: 'h_security', label: 'Phân quyền' },
  { key: 'members', label: 'Thành viên', icon: 'ri-team-line' },
  { key: 'roles', label: 'Vai trò', icon: 'ri-user-settings-line' },
  { key: 'permissions', label: 'Phân quyền', icon: 'ri-shield-keyhole-line' },
  { key: 'router', label: 'Security Center', icon: 'ri-shield-check-fill' },
  { key: 'activity', label: 'Nhật ký', icon: 'ri-history-line' },

  { type: 'heading', key: 'h_data', label: 'Dữ liệu chuyên môn' },
  { key: 'categories', label: 'Danh mục tĩnh', icon: 'ri-folder-3-line' },
  { key: 'warehouses', label: 'Quản lý Kho bãi', icon: 'ri-store-2-line' },
  { key: 'partners', label: 'Đối tác & NCC', icon: 'ri-community-line' },
  { key: 'templates', label: 'Mẫu biểu văn bản', icon: 'ri-file-list-3-line' },

  { type: 'heading', key: 'h_integration', label: 'Hệ thống mở rộng' },
  { key: 'integrations', label: 'App Tích hợp', icon: 'ri-plug-2-line' },
  { key: 'backup', label: 'Sao lưu & khôi phục', icon: 'ri-database-2-line' },
];

interface SettingsMenuProps {
  activeKey: string;
  onChange: (key: string) => void;
}

export function SettingsMenu({ activeKey, onChange }: SettingsMenuProps) {
  return (
    <nav className="rounded-md border border-slate-200 bg-white p-3 shadow-sm space-y-2">
      <div className="lg:hidden">
        <select
          value={activeKey}
          onChange={(event) => onChange(event.target.value)}
          className="w-full rounded-md border border-slate-200 bg-white p-3 text-xs font-medium text-slate-800 outline-none focus:border-emerald-600"
        >
          {menuItems.filter(item => !item.type).map((item) => (
            <option key={item.key} value={item.key}>{item.label}</option>
          ))}
        </select>
      </div>

      <div className="hidden lg:block space-y-1 pb-4">
        {menuItems.map((item) => {
          if (item.type === 'heading') {
            return (
              <div key={item.key} className="pt-4 pb-1 pl-3 text-xs font-medium tracking-widest text-slate-400 uppercase">
                {item.label}
              </div>
            );
          }

          const active = item.key === activeKey;
          return (
            <button
              key={item.key}
              type="button"
              onClick={() => onChange(item.key)}
              className={`group flex w-full items-center gap-3 rounded-md px-3 py-2.5 text-left text-xs font-medium transition-all ${active ? 'bg-emerald-50 text-emerald-700 shadow-sm shadow-emerald-900/5' : 'text-slate-600 hover:bg-slate-50 hover:text-emerald-700'
                }`}
            >
              <i className={`${item.icon} text-lg transition-colors ${active ? 'text-emerald-600' : 'text-slate-400 group-hover:text-emerald-500'}`} />
              <span>{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
